/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorstCallV2Model { 
    callId?: string;
    callDate?: string;
    operatorName?: string;
    operatorPhone?: string;
    clientPhone?: string;
    clientName?: string;
    operatorScore?: number;
    clientSentiment?: string;
    category?: string;
    escalation?: boolean;
    flags?: Array<string>;
    summary?: string;
    reviewed?: boolean;
    reviewedDate?: string;
    reviewedBy?: number;
}

